export const confirmation_FR = (name: string) => {
  return `<p style="padding-top: 16px; border-top: 1px solid #eaeaea">Bonjour ${name},</p>
   <p style="color: #000000;">
      Nous vous remercions pour votre prise de contact avec VivaMobility.<br/>
      Votre message a bien été reçu et a été transmis à notre équipe.
    </p>
    <p style="color: #000000;">
      Nous reviendrons vers vous dans les plus brefs délais.<br/>
      En attendant, n’hésitez pas à consulter notre site ou à nous suivre sur nos réseaux sociaux pour en savoir plus sur nos solutions de mobilité intelligente.
    </p>
    <p style="color: #000000;padding-top: 16px; border-top: 1px solid #eaeaea">
      À très bientôt,<br/>
      L’équipe VivaMobility
    </p>`;
};
export const confirmation_EN = (name: string) => {
  return `<p style="padding-top: 16px; border-top: 1px solid #eaeaea">Hello ${name},</p>
    <p style="color: #000000;">
      Thank you for reaching out to VivaMobility.<br/>
We have received your message and forwarded it to the appropriate team.
    </p>
    <p style="color: #000000;">
      We will get back to you as soon as possible.<br/>
In the meantime, feel free to explore our website or follow us on social media to learn more about our smart mobility solutions.
    </p>
    <p style="padding-top: 16px; border-top: 1px solid #eaeaea;color: #000000;">
      Best regards,<br/>
     The VivaMobility Team
    </p>`;
};
export const newContact_FR = (contact: any) => {
  return `<p style="padding-top: 16px; border-top: 1px solid #eaeaea">Bonjour,</p>
   <p style="color: #000000;">
     Une nouvelle demande de contact a été reçue via le site web. Voici les informations fournies :
    </p>
        <p style="color: #000000;">
    <li> <strong>Nom du client :</strong> ${contact.name}</li>
    <li> <strong>Société : ${contact.companyName}</strong></li>
      <li> <strong>Adresse email : ${contact.email}</strong></li>
      <li><strong>Subject: ${contact.subject}</strong></li>
    </p>
    <br/>
  <p style="color: #000000;">
     Merci de traiter cette demande dans les meilleurs délais.
    </p>
    <p style="color: #000000;padding-top: 16px; border-top: 1px solid #eaeaea">
      À très bientôt
    </p>`;
};
export const newContact_EN = (contact: any) => {
  return `<p style="padding-top: 16px; border-top: 1px solid #eaeaea">Hello ,</p>
<p style="color: #000000;">
     A new contact request has been received via the website. Here are the details provided:
    </p>
        <p style="color: #000000;">
    <li> <strong>Client name:</strong> ${contact.name}</li>
    <li><strong>Company:</strong> : ${contact.companyName}</li>
      <li> <strong>Email address:</strong> ${contact.email}</li>
      <li><strong>Subject of the request:</strong> ${contact.subject}</li>
    </p>
    <br/>
       <p style="color: #000000;">
     Thank you for processing this request as soon as possible.
    </p>
    <p style="color: #000000;padding-top: 16px; border-top: 1px solid #eaeaea">
    Coordination
    
    </p>`;
};
export const newDemo_FR = (contact: any) => {
  return `<p style="padding-top: 16px; border-top: 1px solid #eaeaea">Bonjour,</p>
   <p style="color: #000000;">
     Une nouvelle demande de contact a été reçue via le site web. Voici les informations fournies :
    </p>
        <p style="color: #000000;">
    <li> <strong>Nom du client :</strong> ${contact.name}</li>
     <li> <strong>Société : ${contact.companyName}</strong></li>
      <li> <strong>Adresse email : ${contact.email}</strong></li>
       <li> <strong>Numéro téléphone : ${contact.phone}</strong></li>
      <li><strong>Modules: ${contact.modules}</strong></li>
      <li><strong>Date préfére: ${contact.date}</strong></li>
    </p>
    <br/>
  <p style="color: #000000;">
     Merci de traiter cette demande dans les meilleurs délais.
    </p>
    <p style="color: #000000;padding-top: 16px; border-top: 1px solid #eaeaea">
      À très bientôt
    </p>`;
};
export const newDemo_EN = (contact: any) => {
  return `<p style="padding-top: 16px; border-top: 1px solid #eaeaea">Hello ,</p>
<p style="color: #000000;">
     A new contact request has been received via the website. Here are the details provided:
    </p>
        <p style="color: #000000;">
    <li> <strong>Client name:</strong> ${contact.name}</li>
        <li><strong>Company:</strong> : ${contact.companyName}</li>
      <li> <strong>Email address:</strong> ${contact.email}</li>
      <li><strong>Phone:</strong> ${contact.phone}</li>
          <li><strong>Modules:</strong> : ${contact.modules}</li>
      <li><strong>Preferred time:</strong> ${contact.date}</li>
    </p>
    <br/>
       <p style="color: #000000;">
     Thank you for processing this request as soon as possible.
    </p>
    <p style="color: #000000;padding-top: 16px; border-top: 1px solid #eaeaea">
    Coordination
    
    </p>`;
};
